import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import VideoCatalog from '../components/VideoCatalog/VideoCatalog';

const Film = () => {
  const videos = useMemo(
    () => [
      {
      url: '/higher_res_o_humanos.mp4',
      title: 'HUMANO SEGUROS',
      desc:'THE TABLE',
      director: 'DIR.: TOMÁS DE LAS HERAS',
      agencia: 'Agencia 1'
    },
    {
      url: '/higher_res_o_hellmans.mp4',
      title: 'HELLMANN’S “HISTORIAS DE HELADERA”',
      slug: "HELLMANNS",
      desc: 'OGILVY',
      director: 'DIR.: GLUTEN MORGEN & TOMÁS DE LAS HERAS',
      agencia: 'Agencia 1'
    },
    {
        url: '/higher_res_o_bronco_cropped.mp4',
      title: 'FORD BRONCO',
      description: 'FORD',
      director: 'DIR.: MARCELO SZECHTMAN',
      agencia: 'Agencia 1'
    },
    {
      url: '/higher_res_o_amadita.mp4',
      title: 'AMADITA LABORATORIOS',
      desc:'DENTSU',
      director: 'DIR.: SEBA MEGA DÍAZ',
      agencia: 'Agencia 1'
    }
    ],
    []
  );

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <VideoCatalog videos={videos} />
    </Box>
  );
};

export default Film;
